import { NotifyService, Emitter, Message } from './interfaces';

export class NotifyServiceImpl implements NotifyService {

    protected readonly onDidMessageReceiveEmitter = new Emitter<Message>();
    readonly onDidMessageReceive = this.onDidMessageReceiveEmitter.event;

    handleMessageReceive(message: Message): void {
        this.onDidMessageReceiveEmitter.fire(message);
    }
}
